import { AccountDetailsEventFlow, TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

type TrackLeadingBidderModalViewedPayload = TrackingPayload & {
    eventFlow: AccountDetailsEventFlow;
};

export const trackLeadingBidderModalViewedAnalytics = (payload: TrackLeadingBidderModalViewedPayload) => {
    track(TrackingEvents.AuthModal.LeadingBidderModalViewed, payload);
};

export const useTrackLeadingBidderModalViewedAnalytics = () => {
    const { pathname, search } = useLocation();
    const urlWithoutQuery = useAppSelector((state) => getUrlFromPathname(state, pathname));
    const url = search ? `${urlWithoutQuery}${search}` : urlWithoutQuery;

    return useCallback(() => {
        trackLeadingBidderModalViewedAnalytics({
            eventFlow: AccountDetailsEventFlow.Bidding,
            pageName: getAmplitudePageNameFromPath(pathname, search),
            url,
        });
    }, [pathname, search, url]);
};
